require("./bootstrap");
import Popover from 'bootstrap/js/dist/popover';
import { Modal } from 'bootstrap';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import BigPicture from "bigpicture";

import AOS from "aos";

AOS.init({
    delay: 100,
    duration: 1000,
});

import Dropzone from "dropzone";
Dropzone.autoDiscover = false;

import autoComplete from "@tarekraafat/autocomplete.js";

// 12.01.23 - Had to remove this functionality as it was breaking on Safari browser on mac.
/*
import lozad from "lozad";
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
*/
// window.addEventListener('load', (event) => {
//     if (document.body.classList.contains("homepage")) {
//         document.querySelector('.loadPage').classList.remove('no-visible');
//     }
// });

if(location.hash == '#callback') {
    $('#callMeBackModal').modal('show');
}

// screen darken
document.addEventListener("DOMContentLoaded", function () {
    document
        .querySelectorAll(".navbar .dropdown")
        .forEach(function (everydropdown) {
            everydropdown.addEventListener("shown.bs.dropdown", function () {
                var el_overlay = document.createElement("span");
                el_overlay.className = "screen-darken";
                document.body.appendChild(el_overlay);
            });

            everydropdown.addEventListener("hide.bs.dropdown", function () {
                document.body.removeChild(
                    document.querySelector(".screen-darken")
                );
            });
        });

    document
        .querySelector("#top-button")
        .addEventListener("click", function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
});

if (document.body.classList.contains("homepage")) {
    //display logo
    window.addEventListener("scroll", function () {
        var elementTarget = document.querySelector(".home-header-quote");
        var logo = document.querySelector(".navbar-brand");
        if (
            window.scrollY >
            elementTarget.offsetTop + elementTarget.offsetHeight
        ) {
            logo.classList.add("logo-show");
            logo.classList.remove("logo-hide");
        } else {
            logo.classList.add("logo-hide");
            logo.classList.remove("logo-show");
        }
    });

    //animate pets
    // ScrollTrigger.matchMedia({

    //     "(min-width: 800px)": function () {
    //         const tl = gsap.timeline({
    //             scrollTrigger: {
    //                 trigger: ".home-pets",
    //                 start: "center bottom",
    //                 end: "center top",
    //                 scrub: true,
    //                 markers: false
    //             }
    //         });

    //         tl.add('start');
    //         tl.to(".dog", { x: 150, duration: 1 }, 'start');
    //         tl.to(".cat", { x: -150, duration: 1 }, 'start');
    //         tl.to(".horse", { scale: 0.8, duration: 1 }, 'start')
    //     }

    // });

    // Youtube Video
    // document
    //     .querySelector(".youtube-vid")
    //     .addEventListener("click", function (e) {
    //         BigPicture({
    //             el: e.target,
    //             ytSrc: e.target.getAttribute("ytSrc"),
    //         });
    //     });
}

if (document.body.classList.contains("quoteForm")) {
    var btnNext = document.querySelector(".btn-next");

    // Next button, show next part of form
    btnNext.addEventListener("click", function (e) {
        btnNext.classList.add("no-visible");
        document.querySelector(".your-details").classList.remove("no-visible");
    });

    // Change breed list for cats/dogs
    document.body.addEventListener("change", function (e) {
        var breedUrl = "";
        var breedList = document.querySelector("select[name=Breed]");

        if (e.target.value == "cat") {
            breedUrl = "/quoteForm/cats";
        } else if (e.target.value == "dog") {
            breedUrl = "/quoteForm/dogs";
        }

        if (e.target.value == "cat" || e.target.value == "dog") {
            var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

            fetch(breedUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    url: breedUrl,
                    "X-CSRF-Token": CSRF_TOKEN,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    //remove all options
                    while (breedList.options.length > 1) {
                        breedList.remove(1);
                    }
                    //loop through json and append to select
                    data.forEach((obj) => {
                        const option = new Option(obj, obj);
                        breedList.add(option);
                    });
                })
                .catch(function (error) {
                    console.error("Error:", error);
                });
        }
    });

    // Form submit
    const form = document.getElementById("quote-form");
    form.addEventListener("submit", function (e) {
        var btn = document.querySelector('#quote-form button[type=submit]');
        // If the form is NOT currently submitting
        if (!btn.hasAttribute('data-original')) {
            // Add the .disabled class
            btn.classList.add('disabled');

            // Store the original text to a data attribute
            btn.setAttribute('data-original', btn.textContent);

            // Update the button text
            btn.textContent = 'Processing, please wait...';
        }
    });

    // Form submit
    // const form = document.getElementById("quote-form");
    // form.addEventListener("submit", function (e) {
    //     e.preventDefault();
    //     var submit = document.querySelector("#quote-form button[type=submit]");
    //     submit.disabled = true;
    //     submit.innerHTML = 'PLEASE WAIT...';
    //     var formData = new FormData(e.target);
    //     fetch("/quoteForm/submit", {
    //         method: "POST",
    //         body: formData,
    //     })
    //         .then((response) => response.json())
    //         .then((data) => {
    //             var message = document.getElementById("message");

    //             message.className = "";
    //             if (data.success) {
    //                 // message.classList.add("alert", "alert-success");
    //                 // message.innerText = data.success;
    //                 // document.querySelector('.main-form').scrollIntoView();
    //                 window.location.href = data.success;
    //             }
    //             if (data.error) {
    //                 message.classList.add("alert", "alert-danger");
    //                 message.innerText = data.error;
    //                 document.querySelector('.main-form').scrollIntoView();
    //             }
    //             submit.disabled = false;
    //             submit.innerHTML = "SEND";
    //         });
    // });

    // First step, had a quote before?
    // document
    //     .querySelector(".btn-proceed")
    //     .addEventListener("click", function (e) {
    //         e.preventDefault();
    //         document.querySelector(".prev-form").classList.add("no-visible");
    //         document.querySelector(".main-form").classList.remove("no-visible");
    //     });
}

if (document.body.classList.contains("quoteFormSales")) {
    // Discount select
    const plans = [ 'plan1', 'plan2', 'plan3', 'plan4', 'plan9', 'plan10', 'plan11', 'plan12' ];
    document.querySelectorAll('input[name=plan]').forEach((elem) => {
        elem.addEventListener('click', function(e) {
            if(elem.checked && elem.classList.contains('show-discounts')) {
                document.querySelector('.sales-discount').classList.remove('no-visible');
            } else {
                document.querySelector('.sales-discount').classList.add('no-visible');
            }
            if(plans.includes(elem.getAttribute('value'))) {
                document.querySelector('input[name=planType]').value = 'BASIC';
            } else {
                document.querySelector('input[name=planType]').value = 'DIAMOND';
            }
        });
    });

    // Form submit
    const form = document.getElementById("quote-form");
    form.addEventListener("submit", function (e) {
        var btn = document.querySelector('#quote-form button[type=submit]');
        // If the form is NOT currently submitting
        if (!btn.hasAttribute('data-original')) {
            // Add the .disabled class
            btn.classList.add('disabled');

            // Store the original text to a data attribute
            btn.setAttribute('data-original', btn.textContent);

            // Update the button text
            btn.textContent = 'Processing, please wait...';
        }
    });
}

if (document.body.classList.contains("quote2")) {
    // Set EU Cover
    document.querySelectorAll('#european-cover .option').forEach((elem) => {
        elem.addEventListener('click', function(e) {

            document.querySelectorAll('#european-cover .option').forEach((elem) => {
                elem.classList.remove('active');
            });
            elem.classList.add('active');

            // If plan is already selected then update total price
            document.querySelectorAll('#select-plan .option').forEach((elem) => {
                if(elem.classList.contains('active')) {
                    if(elem.getAttribute('data-plan') == 'standard') {
                        updateStandard();
                    } else if(elem.getAttribute('data-plan') == 'diamond') {
                        updateDiamond();
                    }
                }
            });
        });
    });

    // Update totals when a plan is selected
    var btn_standard = document.querySelector('#select-plan .option[data-plan=standard]');
    var btn_diamond = document.querySelector('#select-plan .option[data-plan=diamond]');

    btn_standard.addEventListener('click', function(e) {
        btn_diamond.classList.remove('active');
        btn_standard.classList.add('active');
        updateStandard();
    });

    btn_diamond.addEventListener('click', function(e) {
        btn_diamond.classList.add('active');
        btn_standard.classList.remove('active');
        updateDiamond();
    });

    // Terms & Conditions selector
    var tc_unselected = document.querySelector('.view-terms-btn');
    var tc_standard = document.querySelector('.btnTCStandard');
    var tc_diamond = document.querySelector('.btnTCDiamond');

    document.querySelector('#select-plan .option[data-plan=standard]').addEventListener('click', function(e) {
        tc_unselected.classList.add('d-none');
        tc_diamond.classList.add('d-none');
        tc_standard.classList.remove('d-none');
    });

    document.querySelector('#select-plan .option[data-plan=diamond]').addEventListener('click', function(e) {
        tc_unselected.classList.add('d-none');
        tc_standard.classList.add('d-none');
        tc_diamond.classList.remove('d-none');
    });

    // Form submit
    const form = document.getElementById("pre-checkout-form");
    form.addEventListener("submit", function (e) {
        if(!document.querySelector('#select-plan .option[data-plan=standard]').classList.contains('active') &&
            !document.querySelector('#select-plan .option[data-plan=diamond]').classList.contains('active')) {
            e.preventDefault();
            alert('Please select a plan first');
        }
    });

    // Update standard totals
    function updateStandard() {
        var coverValue = document.querySelector('#european-cover .option.active').getAttribute('data-value');
        var monthly = document.querySelector('#european-cover .option.active').getAttribute('data-standard-monthly');
        // var annual = document.querySelector('#european-cover .option.active').getAttribute('data-standard-annual');

        document.querySelector('#pre-checkout .total span').innerHTML = '€' + monthly + ' per month';

        document.querySelector('input[name=plan]').value = 'standard';
        document.querySelector('input[name=europeanCover]').value = coverValue;
    }

    // Update diamond totals
    function updateDiamond() {
        var coverValue = document.querySelector('#european-cover .option.active').getAttribute('data-value');
        var monthly = document.querySelector('#european-cover .option.active').getAttribute('data-diamond-monthly');
        // var annual = document.querySelector('#european-cover .option.active').getAttribute('data-diamond-annual');

        document.querySelector('#pre-checkout .total span').innerHTML = '€' + monthly + ' per month';

        document.querySelector('input[name=plan]').value = 'diamond';
        document.querySelector('input[name=europeanCover]').value = coverValue;
    }

}

if (document.body.classList.contains("quote3")) {
    // document.querySelector('#paymentTypeCard').addEventListener('change', function(e) {
    //     document.querySelector('.direct-debit').classList.add('d-none');
    //     document.querySelectorAll('.direct-debit input').forEach((elem) => {
    //         elem.removeAttribute('required');
    //     });
    // });

    // document.querySelector('#paymentTypeDirectDebit').addEventListener('change', function(e) {
    //     document.querySelector('.direct-debit').classList.remove('d-none');
    //     document.querySelectorAll('.direct-debit input').forEach((elem) => {
    //         elem.setAttribute('required', '');
    //     });
    // });

    // Form submit
    const form = document.getElementById("checkoutForm");
    form.addEventListener("submit", function (e) {
        var btn = document.querySelector('#checkoutForm button[type=submit]');
        // If the form is NOT currently submitting
        if (!btn.hasAttribute('data-original')) {
            // Add the .disabled class
            btn.classList.add('disabled');

            // Store the original text to a data attribute
            btn.setAttribute('data-original', btn.textContent);

            // Update the button text
            btn.textContent = 'Processing, please wait...';
        }
    });
}

if (document.body.classList.contains("horseForm")) {
    var btnNext = document.querySelector(".btn-next");

    // Next button, show next part of form
    btnNext.addEventListener("click", function (e) {
        btnNext.classList.add("no-visible");
        document.querySelector(".your-details").classList.remove("no-visible");
    });

    // Form submit
    const form = document.getElementById("quote-form");
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        var submit = document.querySelector("#quote-form button[type=submit]");
        submit.disabled = true;
        submit.innerHTML = 'PLEASE WAIT...';
        var formData = new FormData(e.target);
        fetch("/horseForm/submit", {
            method: "POST",
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                var message = document.getElementById("message");

                message.className = "";
                if (data.success) {
                    window.location.href = data.success;
                }
                if (data.error) {
                    message.classList.add("alert", "alert-danger");
                    message.innerText = data.error;
                }
                submit.disabled = false;
                submit.innerHTML = "SEND";
            });
    });
}

if (document.body.classList.contains("travelFormCustomer")) {
    // Change breed list for cats/dogs
    document.body.addEventListener("change", function (e) {
        var breedUrl = "";
        var breedList = document.querySelector("select[name=Breed]");

        if (e.target.value == "cat") {
            breedUrl = "/quoteForm/cats";
        } else if (e.target.value == "dog") {
            breedUrl = "/quoteForm/dogs";
        }

        if (e.target.value == "cat" || e.target.value == "dog") {
            var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

            fetch(breedUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    url: breedUrl,
                    "X-CSRF-Token": CSRF_TOKEN,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    //remove all options
                    while (breedList.options.length > 1) {
                        breedList.remove(1);
                    }
                    //loop through json and append to select
                    data.forEach((obj) => {
                        const option = new Option(obj, obj);
                        breedList.add(option);
                    });
                })
                .catch(function (error) {
                    console.error("Error:", error);
                });
        }
    });
};

if (document.body.classList.contains("travelFormAgent")) {
    // Change breed list for cats/dogs
    document.body.addEventListener("change", function (e) {
        var breedUrl = "";
        var breedList = document.querySelector("select[name=Breed]");

        if (e.target.value == "cat") {
            breedUrl = "/quoteForm/cats";
        } else if (e.target.value == "dog") {
            breedUrl = "/quoteForm/dogs";
        }

        if (e.target.value == "cat" || e.target.value == "dog") {
            var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

            fetch(breedUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    url: breedUrl,
                    "X-CSRF-Token": CSRF_TOKEN,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    //remove all options
                    while (breedList.options.length > 1) {
                        breedList.remove(1);
                    }
                    //loop through json and append to select
                    data.forEach((obj) => {
                        const option = new Option(obj, obj);
                        breedList.add(option);
                    });
                })
                .catch(function (error) {
                    console.error("Error:", error);
                });
        }
    });
};

if (document.body.classList.contains("travelForm")) {
    var btnNext = document.querySelector(".btn-next");

    // Next button, show next part of form
    btnNext.addEventListener("click", function (e) {
        btnNext.classList.add("no-visible");
        document.querySelector(".your-details").classList.remove("no-visible");
    });

    // Form submit
    const form = document.getElementById("quote-form");
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        var submit = document.querySelector("#quote-form button[type=submit]");
        submit.disabled = true;
        submit.innerHTML = 'PLEASE WAIT...';
        var formData = new FormData(e.target);
        fetch("/travelForm/submit", {
            method: "POST",
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                var message = document.getElementById("message");

                message.className = "";
                if (data.success) {
                    window.location.href = data.success;
                }
                if (data.error) {
                    message.classList.add("alert", "alert-danger");
                    message.innerText = data.error;
                }
                submit.disabled = false;
                submit.innerHTML = "SEND";
            });
    });

    // Change breed list for cats/dogs
    document.body.addEventListener("change", function (e) {
        var breedUrl = "";
        var breedList = document.querySelector("select[name=Breed]");

        if (e.target.value == "cat") {
            breedUrl = "/quoteForm/cats";
        } else if (e.target.value == "dog") {
            breedUrl = "/quoteForm/dogs";
        }

        if (e.target.value == "cat" || e.target.value == "dog") {
            var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

            fetch(breedUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    url: breedUrl,
                    "X-CSRF-Token": CSRF_TOKEN,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    //remove all options
                    while (breedList.options.length > 1) {
                        breedList.remove(1);
                    }
                    //loop through json and append to select
                    data.forEach((obj) => {
                        const option = new Option(obj, obj);
                        breedList.add(option);
                    });
                })
                .catch(function (error) {
                    console.error("Error:", error);
                });
        }
    });
}

if (document.body.classList.contains("liabilityForm")) {
    var btnNext = document.querySelector(".btn-next");

    // Next button, show next part of form
    btnNext.addEventListener("click", function (e) {
        btnNext.classList.add("no-visible");
        document.querySelector(".your-details").classList.remove("no-visible");
    });

    // Form submit
    const form = document.getElementById("quote-form");
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        var submit = document.querySelector("#quote-form button[type=submit]");
        submit.disabled = true;
        submit.innerHTML = 'PLEASE WAIT...';
        var formData = new FormData(e.target);
        fetch("/liabilityForm/submit", {
            method: "POST",
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                var message = document.getElementById("message");

                message.className = "";
                if (data.success) {
                    window.location.href = data.success;
                }
                if (data.error) {
                    message.classList.add("alert", "alert-danger");
                    message.innerText = data.error;
                }
                submit.disabled = false;
                submit.innerHTML = "SEND";
            });
    });
}

if (document.body.classList.contains("agentQuoteForm")) {

    // Change breed list for cats/dogs
    document.body.addEventListener("change", function (e) {
        var breedUrl = "";
        var breedList = document.querySelector("select[name=Breed]");

        // Set up correct cover options
        if (e.target.value == 'cat') {
            document.querySelector('select[name=Cover] optgroup#dogs').classList.add('no-visible');
            document.querySelector('select[name=Cover] optgroup#cats').classList.remove('no-visible');
        } else if (e.target.value == "dog") {
            document.querySelector('select[name=Cover] optgroup#cats').classList.add('no-visible');
            document.querySelector('select[name=Cover] optgroup#dogs').classList.remove('no-visible');
        }

        if (e.target.value == "cat") {
            breedUrl = "/quoteForm/cats";
        } else if (e.target.value == "dog") {
            breedUrl = "/quoteForm/dogs";
        }

        if (e.target.value == "cat" || e.target.value == "dog") {
            var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

            fetch(breedUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    url: breedUrl,
                    "X-CSRF-Token": CSRF_TOKEN,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    //remove all options
                    while (breedList.options.length > 1) {
                        breedList.remove(1);
                    }
                    //loop through json and append to select
                    data.forEach((obj) => {
                        const option = new Option(obj, obj);
                        breedList.add(option);
                    });
                })
                .catch(function (error) {
                    console.error("Error:", error);
                });
        }
    });

}

if (document.body.classList.contains("view-quote")) {

    // Set EU Cover cost
    document.querySelectorAll('input[name=europeanCover]').forEach((elem) => {
        elem.addEventListener('change', function(e) {
            document.querySelector('.euCoverCost').textContent = e.target.value;
            document.querySelector('#quoteModal input[name=europeanCover]').value = e.target.value;
            document.querySelector('#diamondModal input[name=europeanCover]').value = e.target.value;

            if(e.target.value == 0) {
                document.querySelector('#quoteModal .european-cover').classList.add('no-visible');
                document.querySelector('#diamondModal .european-cover').classList.add('no-visible');
            } else {
                document.querySelector('#quoteModal .european-cover span.price').textContent = e.target.value;
                document.querySelector('#quoteModal .european-cover').classList.remove('no-visible');
                document.querySelector('#diamondModal .european-cover span.price').textContent = e.target.value;
                document.querySelector('#diamondModal .european-cover').classList.remove('no-visible');
            }
        });
    });

    // Plan select for T&Cs
    const btn_tc = document.querySelector('.view-terms-btn');
    const btn_standard = document.querySelector('.btnTCStandard');
    const btn_diamond = document.querySelector('.btnTCDiamond');

    document.querySelector('input#standard').addEventListener('click', function(e) {
        btn_tc.classList.add('d-none');
        btn_diamond.classList.add('d-none');
        btn_standard.classList.remove('d-none');
    });

    document.querySelector('input#diamond').addEventListener('click', function(e) {
        btn_tc.classList.add('d-none');
        btn_standard.classList.add('d-none');
        btn_diamond.classList.remove('d-none');
    });

    // Form submit after agreeing
    window.addEventListener('load', function() {
        document.getElementById('quote-form').addEventListener('submit', function(e) {
                e.preventDefault();

                if(document.querySelector('input#standard:checked')) {
                    // alert('standard');
                    // new bootstrap.Modal(document.getElementById('tcStandardModal'));
                    $('#quoteModal').modal('show');
                }

                if(document.querySelector('input#diamond:checked')) {
                    // alert('diamond');
                    // new bootstrap.Modal(document.getElementById('tcStandarModal'));
                    $('#diamondModal').modal('show');
                }
        });
    });

    document
        .querySelector("#quoteModal #monthly")
        .addEventListener("click", function () {
            document
                .querySelector("#quoteModal .annual-price")
                .classList.add("no-visible");
            document
                .querySelector("#quoteModal .monthly-price")
                .classList.remove("no-visible");
        });

    document
        .querySelector("#quoteModal #annual")
        .addEventListener("click", function () {
            document
                .querySelector("#quoteModal .annual-price")
                .classList.remove("no-visible");

            document
                .querySelector("#quoteModal .monthly-price")
                .classList.add("no-visible");
        });

    document
        .querySelector("#quoteModal #directdebit")
        .addEventListener("click", function () {
            document
                .querySelector("#quoteModal .direct-debit")
                .classList.remove("d-none");
                var inputs = document.querySelectorAll("#quoteModal .direct-debit input[type=text]");

                [].forEach.call(inputs, function(input) {
                    input.setAttribute('required', '');
                });
        });
    document
        .querySelector("#quoteModal #card")
        .addEventListener("click", function () {
            document
                .querySelector("#quoteModal .direct-debit")
                .classList.add("d-none");
                var inputs = document.querySelectorAll("#quoteModal .direct-debit input[type=text]");

                [].forEach.call(inputs, function(input) {
                    input.removeAttribute('required');
                });
        });

    // document.querySelector('#quoteModal select[name=europeanCover]').addEventListener('change', function(e) {
    //     var travel = e.target.value;
    //     if(travel == 0) {
    //         document.querySelector('#quoteModal .european-cover').classList.add('no-visible');
    //     } else {
    //         document.querySelector('#quoteModal .european-cover span.price').textContent = e.target.value;
    //         document.querySelector('#quoteModal .european-cover').classList.remove('no-visible');
    //     }

    // });

    document
        .querySelector("#diamondModal #monthly")
        .addEventListener("click", function () {
            document
                .querySelector("#diamondModal .annual-price")
                .classList.add("no-visible");
            document
                .querySelector("#diamondModal .monthly-price")
                .classList.remove("no-visible");
        });

    document
        .querySelector("#diamondModal #annual")
        .addEventListener("click", function () {
            document
                .querySelector("#diamondModal .annual-price")
                .classList.remove("no-visible");
            document
                .querySelector("#diamondModal .monthly-price")
                .classList.add("no-visible");
        });

    document
        .querySelector("#diamondModal #directdebit")
        .addEventListener("click", function () {
            document
                .querySelector("#diamondModal .direct-debit")
                .classList.remove("d-none");
                var inputs = document.querySelectorAll("#diamondModal .direct-debit input[type=text]");

                [].forEach.call(inputs, function(input) {
                    input.setAttribute('required', '');
                });
        });
    document
        .querySelector("#diamondModal #card")
        .addEventListener("click", function () {
            document
                .querySelector("#diamondModal .direct-debit")
                .classList.add("d-none");
                var inputs = document.querySelectorAll("#diamondModal .direct-debit input[type=text]");

                [].forEach.call(inputs, function(input) {
                    input.removeAttribute('required');
                });
        });

    // document.querySelector('#diamondModal select[name=europeanCover]').addEventListener('change', function(e) {
    //     var travel = e.target.value;
    //     if(travel == 0) {
    //         document.querySelector('#diamondModal .european-cover').classList.add('no-visible');
    //     } else {
    //         document.querySelector('#diamondModal .european-cover span.price').textContent = e.target.value;
    //         document.querySelector('#diamondModal .european-cover').classList.remove('no-visible');
    //     }

    // });

    // Form submit after clicking pay now
    window.addEventListener('load', function() {
        document.getElementById('paymentFormStandard').addEventListener('submit', function(e) {
                // e.preventDefault();

                document.querySelector('#paymentFormStandard input[type=submit]').disabled;
                document.querySelector('#paymentFormStandard input[type=submit]').value = 'PLEASE WAIT...';
        });

        document.getElementById('paymentFormDiamond').addEventListener('submit', function(e) {
            // e.preventDefault();

            document.querySelector('#paymentFormDiamond input[type=submit]').disabled;
            document.querySelector('#paymentFormDiamond input[type=submit]').value = 'PLEASE WAIT...';
    });
    });
}

if (document.body.classList.contains("portal")) {
    if(document.querySelector(".contact-details") != null) {
        // Modal
        const buttons = document.querySelectorAll(".contact-details");
        let modal = new Modal(document.getElementById('contactDetailsModal'));
        for (const button of buttons) {
            button.addEventListener('click', function(event) {
                document.querySelector("#contactDetailsModal .modal-body").innerHTML = '<i class="fas fa-spinner fa-pulse"></i> Please wait...';
                var contact_id = button.getAttribute('data-contact-id');
                fetch("/clientContact/" + contact_id)
                .then(response => {
                    return response.text()
                })
                .then(data => {
                    // document.querySelector("#contactDetailsModal .modal-body").innerHTML = '';
                    document.querySelector("#contactDetailsModal .modal-body").innerHTML = data;
                });
                // $('#contactDetailsModal').modal('show');
                modal.show();
            }
        )};
    }
}

if (document.body.classList.contains("agentSearchClient")) {
    // New Client Form for Agents
    document.querySelector('#add-client-btn').addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('.add-client-form').classList.toggle('no-visible');
    });
}

if (document.body.classList.contains("quoteFormCustomer")) {

    // Change breed list for cats/dogs
    document.body.addEventListener("change", function (e) {
        var breedUrl = "";
        var breedList = document.querySelector("select[name=Breed]");

        if (e.target.value == "cat") {
            breedUrl = "/quoteForm/cats";
        } else if (e.target.value == "dog") {
            breedUrl = "/quoteForm/dogs";
        }

        if (e.target.value == "cat" || e.target.value == "dog") {
            var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

            fetch(breedUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    url: breedUrl,
                    "X-CSRF-Token": CSRF_TOKEN,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    //remove all options
                    while (breedList.options.length > 1) {
                        breedList.remove(1);
                    }
                    //loop through json and append to select
                    data.forEach((obj) => {
                        const option = new Option(obj, obj);
                        breedList.add(option);
                    });
                })
                .catch(function (error) {
                    console.error("Error:", error);
                });
        }
    });
}

if (document.body.classList.contains("register-vet")) {
    document.querySelector('#count').innerHTML = (5000 - document.querySelector('#vet-bio').value.length);

    document.querySelector('#vet-bio').addEventListener('keyup', (e) => {
        document.querySelector('#count').innerHTML = (5000 - e.target.value.length);
    });
}

if (document.body.classList.contains("register-vet-step2")) {

    let vet_logo_dropzone = new Dropzone("#vet-logo-upload", {
        maxFiles: 1,
        maxFilesize: 5,
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        paramName: 'file',
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        url: '/register-vet/step2/submit',

        init: function() {
            this.on('sending', function (data, xhr, formData) {
                formData.append("id", document.querySelector('input[name=id]').value);
            });
            this.on('queuecomplete', function () {
                if(vet_logo_dropzone.getRejectedFiles().length == 0) {
                    location.reload();
                }
            });
        }
    });
}

if (document.body.classList.contains("register-vet-step4")) {
    let vet_gallery_dropzone = new Dropzone("#vet-gallery-upload", {
        maxFiles: 5,
        maxFilesize: 5,
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        paramName: 'file',
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        url: '/register-vet/step4/submit',

        init: function() {
            this.on('sending', function (data, xhr, formData) {
                formData.append("id", document.querySelector('input[name=id]').value);
            });
            // this.on('queuecomplete', function () {
            //     if(vet_gallery_dropzone.getRejectedFiles().length == 0) {
            //         location.reload();
            //     }
            // });
        }
    });
}

if (document.body.classList.contains("directory")) {
    document.querySelector('.btn-call-us-now').addEventListener('click', (e) => {
        document.querySelector('.vet-contact-form').classList.toggle('no-visible');
    });
};

if(typeof(document.getElementById("new-claim-form")) != 'undefined' && document.getElementById("new-claim-form") != null){
    let timer;

    const autoCompleteJS = new autoComplete({
        selector: "#autoComplete",
        placeHolder: "Search for your vet. Use the name or email of the vet.",
        debounce: 500,
        data: {
            src: async (query) => {
            try {
                // Fetch Data from external Source
                const source = await fetch('/searchVets/' + document.querySelector('input[name=contactID]').value + '/' + document.querySelector('input[name=contactToken]').value + '/' + query);
                // Data should be an array of `Objects` or `Strings`
                const data = await source.json();

                return data;
            } catch (error) {
                return error;
            }
            },
            // Data source 'Object' key to be searched
            keys: ['Name', 'Email']
        },
        resultsList: {
            class: 'autoComplete_list',
            noResults: true,
            maxResults: 10,
            tabSelect: true,
        },
        resultItem: {
            class: 'autoComplete_result',
            element: (item, data) => {
                // Modify Results Item Style
                item.style = "display: flex; justify-content: space-between;";
                // Modify Results Item Content
                item.innerHTML = `
                <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; font-size: 0.9em;">
                    ${data.value.Name}<br>${data.value.Email ? data.value.Email + '<br>' : ''}${data.value.Telephone ? data.value.Telephone + '<br>' : ''}
                </span>`;
            },
            highlight: true,
        },
        events: {
            input: {
            focus() {
                if (autoCompleteJS.input.value.length) autoCompleteJS.start();
            },
            selection(event) {
                const feedback = event.detail;
                autoCompleteJS.input.blur();
                // Prepare User's Selected Value
                const selection = feedback.selection.value.id;
                // Render selected choice to selection div
                document.querySelector(".selection").value = selection;
                document.querySelector(".selection_name").value = feedback.selection.value.Name;
                // Replace Input value with the selected value
                autoCompleteJS.input.value = feedback.selection.value.Name;
                // Console log autoComplete data feedback
                // console.log(feedback);
            },
            },
        },
    });

    // New vet form submit
    const form = document.getElementById("new-claim-form");
    form.addEventListener("submit", function (e) {
        // e.preventDefault();
        var submit = document.querySelector("#new-claim-form button[type=submit]");
        submit.disabled = true;
        submit.innerHTML = 'PLEASE WAIT...';


        // var formData = new FormData(e.target);
        // fetch("/customer-claim/newVetSubmit", {
        //     method: "POST",
        //     body: formData,
        // })
        // .then((response) => response.json())
        // .then((data) => {
        //     if(data.status == 'success')
        //     {
        //         document.querySelector('#vet-form').style.display = 'none';
        //         modal.hide();

        //         document.querySelector('#autoComplete').removeAttribute('required');
        //         document.querySelector('#autoComplete').style.display = 'none';
        //         document.querySelector('input[name=vet_ID').value = data.id;
        //         document.querySelector('input[name=vet_Name').value = data.name;

        //         var message = document.getElementById("vet-message-complete");
        //         message.classList.add("alert", "alert-success");
        //         message.innerHTML = 'Your claim has been associated with your vet: <b>' + data.name + '</b>';
        //     } else {
        //         var message = document.getElementById("vet-message");
        //         message.classList.add("alert", "alert-danger");
        //         message.innerText = data.message;
        //         submit.disabled = false;
        //         submit.innerHTML = "Submit Vet";
        //     }
        // });

            
    });
};
